var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#EDE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_83501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7314 7.57115C10.4785 8.36132 10.1229 9.20095 9.66191 9.6619C9.20096 10.1228 8.36133 10.4785 7.57117 10.7314C7.52095 10.7475 7.47094 10.7631 7.42123 10.7783C7.28666 10.8196 7.15436 10.8578 7.02651 10.893C6.97486 10.9072 6.92394 10.9209 6.8739 10.9342C6.64554 10.9945 6.64554 11.4101 6.8739 11.4704C6.92394 11.4837 6.97486 11.4974 7.02651 11.5116C7.15436 11.5468 7.28666 11.585 7.42123 11.6263C7.47094 11.6415 7.52095 11.6571 7.57117 11.6732C8.36133 11.9261 9.20096 12.2817 9.66191 12.7427C10.1229 13.2036 10.4785 14.0433 10.7314 14.8334C10.7475 14.8837 10.7631 14.9337 10.7784 14.9834C10.8196 15.118 10.8578 15.2503 10.893 15.3781C10.9072 15.4298 10.921 15.4807 10.9342 15.5307C10.9945 15.7591 11.4101 15.7591 11.4704 15.5307C11.4837 15.4807 11.4974 15.4298 11.5116 15.3781C11.5468 15.2503 11.585 15.118 11.6263 14.9834C11.6415 14.9337 11.6572 14.8837 11.6732 14.8334C11.9261 14.0433 12.2818 13.2036 12.7427 12.7427C13.2037 12.2817 14.0433 11.9261 14.8335 11.6732C14.8837 11.6571 14.9337 11.6415 14.9834 11.6263C15.118 11.585 15.2503 11.5468 15.3781 11.5116C15.4298 11.4974 15.4807 11.4837 15.5307 11.4704C15.7591 11.4101 15.7591 10.9945 15.5307 10.9342C15.4807 10.9209 15.4298 10.9072 15.3781 10.893C15.2503 10.8578 15.118 10.8196 14.9834 10.7783C14.9337 10.7631 14.8837 10.7475 14.8335 10.7314C14.0433 10.4785 13.2037 10.1228 12.7427 9.6619C12.2818 9.20095 11.9261 8.36132 11.6732 7.57115C11.6572 7.52094 11.6415 7.47092 11.6263 7.42122C11.585 7.28664 11.5468 7.15434 11.5116 7.02649C11.4974 6.97485 11.4837 6.92393 11.4704 6.87388C11.4101 6.64553 10.9945 6.64553 10.9342 6.87388C10.921 6.92393 10.9072 6.97485 10.893 7.02649C10.8578 7.15434 10.8196 7.28665 10.7784 7.42122C10.7631 7.47092 10.7475 7.52094 10.7314 7.57115Z",
    fill: "url(#paint0_linear_1944_83501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61923 4.45799C6.549 4.24732 6.25101 4.24732 6.18078 4.458L5.93277 5.20201C5.81777 5.54702 5.54704 5.81775 5.20203 5.93276L4.45801 6.18076C4.24733 6.25099 4.24733 6.54899 4.45801 6.61921L5.20203 6.86722C5.54704 6.98222 5.81777 7.25295 5.93277 7.59796L6.18078 8.34198C6.25101 8.55266 6.549 8.55266 6.61923 8.34198L6.86723 7.59796C6.98224 7.25295 7.25297 6.98222 7.59798 6.86722L8.342 6.61921C8.55267 6.54899 8.55267 6.25099 8.342 6.18076L7.59798 5.93276C7.25297 5.81775 6.98224 5.54702 6.86723 5.20201L6.61923 4.45799Z",
    fill: "url(#paint1_linear_1944_83501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1944_83501",
    x1: 10.001,
    y1: 4.29999,
    x2: 10.001,
    y2: 15.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1944_83501",
    x1: 10.001,
    y1: 4.29999,
    x2: 10.001,
    y2: 15.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_83501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentImg);
export default __webpack_public_path__ + "static/media/payment_img.a8c40ffbde2a3cf181dd9405879e228b.svg";
export { ForwardRef as ReactComponent };